import React from 'react';
import { Link } from 'react-router-dom';
import ContactForm from '../components/ContactForm';
import { useSchoolInfo } from '../hooks/useSchoolInfo';

export default function VisitPage() {
  const schoolInfo = useSchoolInfo();
  return (
    <div className="bg-white pb-20">
      
      {/* Header Banner following container line */}
      <section className="bg-[#eef4e6] border-b border-[#d9e5d4] py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1D2923] tracking-tight font-serif-heading">
              Besøg Odder Lille Friskole
            </h1>
            <p className="text-base sm:text-lg text-[#5A6961] leading-relaxed">
              Den bedste måde at mærke den trygge og nærværende stemning på er at opleve den i virkeligheden. Kom forbi til en uforpligtende rundvisning og en personlig snak.
            </p>
          </div>
        </div>
      </section>

      {/* Content + Form following container line */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 lg:pt-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          
          {/* Info Column */}
          <div className="lg:col-span-5 space-y-6">
            <div className="bg-[#eef4e6] p-8 rounded-3xl border border-[#d9e5d4] space-y-6">
              <h2 className="text-xl sm:text-2xl font-bold text-[#1D2923] font-serif-heading">
                Hvad kan I forvente af et besøg?
              </h2>

              <ul className="space-y-4 text-sm text-[#4A5850]">
                <li className="flex items-start gap-3">
                  <i className="fa-solid fa-check text-[#264A35] mt-1 text-sm shrink-0" aria-hidden="true" />
                  <div>
                    <strong className="text-[#1D2923] block">Rundvisning i undervisningstiden:</strong>
                    <span className="text-xs sm:text-sm text-[#5A6961]">Se klasselokalerne, værkstederne, udearealerne og Fritteren i funktion.</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="fa-solid fa-check text-[#264A35] mt-1 text-sm shrink-0" aria-hidden="true" />
                  <div>
                    <strong className="text-[#1D2923] block">Mød lærere og elever:</strong>
                    <span className="text-xs sm:text-sm text-[#5A6961]">Mærk den rolige stemning, fordybelsen og det stærke fællesskab.</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="fa-solid fa-check text-[#264A35] mt-1 text-sm shrink-0" aria-hidden="true" />
                  <div>
                    <strong className="text-[#1D2923] block">Samtale over en kop kaffe:</strong>
                    <span className="text-xs sm:text-sm text-[#5A6961]">Få svar på alle jeres praktiske og pædagogiske spørgsmål fra skolelederen.</span>
                  </div>
                </li>
              </ul>

              <div className="pt-4 border-t border-[#d9e5d4] text-xs text-[#5A6961]">
                Du kan også ringe direkte til os på <a href={`tel:${schoolInfo.phoneRaw}`} className="font-bold text-[#264A35] hover:underline whitespace-nowrap">{schoolInfo.phone}</a> for at aftale en dag.
              </div>
            </div>

            <div className="rounded-3xl overflow-hidden shadow-xs border border-[#d9e5d4]">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/7e157867-df92-46f8-b5ca-20179d4d9044/olf12.jpg"
                alt="Udeliv på skolen"
                className="w-full h-48 object-cover"
              />
            </div>
          </div>

          {/* Form */}
          <div className="lg:col-span-7">
            <ContactForm
              defaultSubject="Besøg skolen / Rundvisning"
              formTitle="Book et skolebesøg"
            />
          </div>

        </div>
      </section>

    </div>
  );
}
